export default "__VITE_ASSET__KTcd9U79__"